import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { LocaleContext } from "../../../../routing/LangRouter";

//import constants
import { DEFAULT_FAVORITES_ANSWERS } from "../../../../constants/defaultFavoritesAnswers";

//import images and icons
import { InfoCircle } from "iconsax-react";

function FavoritesHeader({ submitAnswers }) {
    //general variables
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    return (
        <Grid className="favorites__title" container item xs={12} rowGap={1} justifyContent="space-between">
            <Grid container item xs={2} md={0.5} display={{ xs: "none", md: "none" }} justifyContent="center" alignItems="center">
                <InfoCircle size="40" color="var(--complementary-color)" variant="Bold" />
            </Grid>

            <Grid container item xs={12} md={10} rowGap={1} direction="column" justifyContent="space-between" alignItems="flex-start">
                <Grid component="span" container  columnGap={1} alignItems="center">
                    <InfoCircle size="24" color="var(--complementary-color)" variant="Bold" />
                    {locale === "en" ? (
                        <>
                            Welcome to <span className="favorites__atripa"> AtripA</span>!
                        </>
                    ) : locale === "ar" ? (
                        <>
                            مرحباً بك في <span className="favorites__atripa">أتريبا</span>!
                        </>
                    ) : (
                        <>
                            به <span className="favorites__atripa">آتریپا</span> خوش آمدید!
                        </>
                    )}
                </Grid>
                <span>{t("favoritesMessage2")}</span>
            </Grid>

            <Grid container item xs={12} md={1.5} justifyContent="center" alignItems="center">
                <span className="favorites__skip" onClick={e => submitAnswers(e, DEFAULT_FAVORITES_ANSWERS)}>
                    {t("skip")}
                </span>
            </Grid>
        </Grid>
    );
}

export default FavoritesHeader;
